import React from 'react';
import { Input } from 'semantic-ui-react';
import styled from 'styled-components';

const ClientTagsBlock = React.memo(
  ({
    choosedTags,
    setChoosedTags,
    allTags,
    height = '150px',
    // flexBasis = '25%',
    flexBasis = '5%',
    // width = '80%',
    width = '100%',
    isBorder = true,
  }) => {
    const [parentTags, setParentTags] = React.useState([]);
    const [childTags, setСhildTags] = React.useState([]);

    const handleCheckChildTags = React.useCallback(
      (tagId, parent_id) => {
        let newChoosedTagsIds = JSON.parse(JSON.stringify(choosedTags));
        if (newChoosedTagsIds.includes(tagId)) {
          let isChildTagsCheked = false;

          if (parent_id) {
            newChoosedTagsIds = choosedTags.filter((choosedTagId) => choosedTagId !== tagId);
            childTags.forEach((tag) => {
              if (choosedTags.includes(tag.id) && tag.parent_id === tagId) {
                isChildTagsCheked = true;
              }
            });
            if (isChildTagsCheked) {
              return;
            }
          } else {
            newChoosedTagsIds = choosedTags.filter((choosedTagId) => choosedTagId !== tagId);
          }
        } else {
          if (!parent_id) {
            childTags.forEach((childTag) => {
              if (childTag.parent_id === tagId) newChoosedTagsIds.push(childTag.id);
            });
          }
          newChoosedTagsIds.push(tagId);
        }
        setChoosedTags(newChoosedTagsIds);
      },
      [choosedTags, setChoosedTags, parentTags, setParentTags, childTags, setСhildTags],
    );

    React.useEffect(() => {
      const newParentTags = [];
      const newChildTags = [];
      !!allTags.length &&
        allTags.forEach((tag) => {
          if (tag.parent_id) {
            newChildTags.push(tag);
          } else {
            newParentTags.push(tag);
          }
          setСhildTags([...newChildTags]);
          setParentTags([...newParentTags]);
        });
    }, [allTags]);

    const Label = styled.label`
      display: flex;
      cursor: pointer;
      flex-basis: ${flexBasis};
      align-items: center;
      width: 180px;
    `;

    const ProductsTagsContent = styled.div`
      display: flex;
      width: ${width};
      margin: 0 auto;
    `;

    const CheckboxWrapper = isBorder
      ? styled.div`
          width: 100%;
          padding: 5px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          align-items: flex-start;
          height: ${height};
          margin: 0 auto;

          @media (max-width: 580px) {
            width: 100%;
            padding-left: 20%;
          }
        `
      : styled.div`
          padding: 10px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          align-items: flex-start;
          height: ${height};

          @media (max-width: 580px) {
            width: 100%;
            padding-left: 20%;
          }
        `;

    const FilterWrapper = isBorder
      ? styled.div`
          width: 70%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          margin: 15px auto;
          box-sizing: border-box;
          border: 1px solid #c1c1c1;
          border-radius: 5px;
          background: #fff;
          @media (max-width: 992px) {
            width: 75%;
          }
        `
      : styled.div`
           width: 70%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          box-sizing: border-box;
          background: #fff;
          @media (max-width: 992px) {
            width: 75%;
          }
        `;
    return (
      <ProductsTagsContent>
        <FilterWrapper>
          <Title>Pодительские теги продуктов</Title>
          <CheckboxWrapper>
            {!!parentTags.length &&
              parentTags.map((tag) => (
                <Label key={tag.id}>
                  <Input
                    type="checkbox"
                    style={{ width: 'auto' }}
                    value={tag.id}
                    checked={choosedTags.includes(tag.id)}
                    onChange={() => handleCheckChildTags(tag.id)}
                  />
                  <TagName>{tag.name}</TagName>
                </Label>
              ))}
            {!parentTags.length && (
              <NoTagsMessage>
                <p>Теги не найдены</p>
              </NoTagsMessage>
            )}
          </CheckboxWrapper>
        </FilterWrapper>

        <FilterWrapper>
          <Title>Теги со взаимосвязями</Title>
          <CheckboxWrapper>
            {!!childTags.length &&
              childTags.map((tag) => (
                <Label key={tag.id}>
                  <Input
                    type="checkbox"
                    style={{ width: 'auto' }}
                    value={tag.id}
                    checked={choosedTags.includes(tag.id)}
                    onChange={() => handleCheckChildTags(tag.id, tag.parent_id)}
                  />
                  <TagName>{tag.name}</TagName>
                </Label>
              ))}
            {!childTags.length && (
              <NoTagsMessage>
                <p>Теги не найдены</p>
              </NoTagsMessage>
            )}
          </CheckboxWrapper>
        </FilterWrapper>
      </ProductsTagsContent>
    );
  },
);

export default ClientTagsBlock;

const NoTagsMessage = styled.div`
  font-size: 24px;
  text-align: center;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
`;
const Title = styled.div`
  text-align: center;
  width: 100%;
  margin: 5px;
  font-size: 16px;
`;

const TagName = styled.p`
  margin-left: 10px;
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/TagsBlock/ClientTagsBlock.jsx